<div class="reward-token-badge-container">
    <div class="promotion-used-title" *msShowInEpcot="true">{{ promotionUsedTitle }}</div>
    <div class="reward-token-badge-container__row">
        <div class="reward-used-title" *msShowInEpcot="false">{{ rewardUsedTitle }}</div>
        <bs-reward-used-badge [badge]="badge" />
    </div>
</div>
